<section class="nhsuk-grid-row app-width content-section">
  @if (isAlertVisible) {
    <div
      id="alert"
      role="alert"
      aria-live="assertive"
      tabindex="-1"
      class="floating-alert"
      [ngClass]="{
        'alert-success': alertType === 'success',
        'alert-danger': alertType === 'danger',
        'alert-info': alertType === 'info',
      }"
    >
      <span class="mb-0">{{ alertMessage }}</span>
      <button class="close-btn" aria-label="Dismiss alert" (click)="dismissAlert()">×</button>
    </div>
  }

  <h2 #pageTitle class="nhsuk-heading-xl mb-16" tabindex="-1">
    {{ isEditing ? 'Edit Organisation' : 'Add Organisation' }}
  </h2>
  <div class="nhsuk-back-link mb-16">
    <a class="nhsuk-back-link__link" routerLink="/admin/organisations-mapping" tabindex="0">
      <svg
        class="nhsuk-icon nhsuk-icon__chevron-left"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        aria-hidden="true"
        height="24"
        width="24"
      >
        <path
          d="M8.5 12c0-.3.1-.5.3-.7l5-5c.4-.4 1-.4 1.4 0s.4 1 0 1.4L10.9 12l4.3 4.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-5-5c-.2-.2-.3-.4-.3-.7z"
        ></path>
      </svg>
      Back
    </a>
  </div>

  @if (!isLoading) {
    <form [formGroup]="organisationForm" (ngSubmit)="onSubmit()" class="nhsuk-form-group flex flex-col">
      <div
        class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
        [class.invalid]="formSubmitted && organisationForm.controls['orgCode'].errors"
      >
        <label class="nhsuk-label" for="orgCode">Organisation Code</label>
        <input
          class="nhsuk-input"
          id="orgCode"
          name="orgCode"
          type="text"
          placeholder="LXXXXX"
          formControlName="orgCode"
        />
        @if (organisationForm.controls['orgCode'].errors && formSubmitted) {
          <span class="nhsuk-error-message mb-0">
            <span class="nhsuk-u-visually-hidden">Error:</span>
            The Organisation code can't be empty.
          </span>
        }
      </div>

      <div
        class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
        [class.invalid]="formSubmitted && organisationForm.controls['type'].errors"
      >
        <label class="nhsuk-label" for="type">Role Type</label>
        <select class="nhsuk-select" id="type" name="type" formControlName="type">
          <option value="-1" selected>-- Choose a Role Type --</option>
          <option value="GP">GP</option>
          <option value="HV">HV</option>
          <option value="SN">SN</option>
          <option value="PD">PD</option>
          <option value="SG">SG</option>
        </select>
        @if (organisationForm.controls['type'].errors && formSubmitted) {
          <span class="nhsuk-error-message mb-0">
            <span class="nhsuk-u-visually-hidden">Error:</span>
            The Role Type code can't be empty.
          </span>
        }
      </div>

      @if (organisationForm.value.type !== '-1') {
        @if (organisationForm.value.type !== 'GP' && organisationForm.value.type !== 'PD') {
          <div
            class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
            [class.invalid]="formSubmitted && organisationForm.controls['key'].errors"
          >
            <label class="nhsuk-label" for="key">Organisation Key</label>
            <input class="nhsuk-input" id="key" name="key" type="text" formControlName="key" />
            @if (organisationForm.controls['key'].errors && formSubmitted) {
              <span class="nhsuk-error-message mb-0">
                <span class="nhsuk-u-visually-hidden">Error:</span>
                The key can't be empty.
              </span>
            }
          </div>

          <div
            class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
            [class.invalid]="formSubmitted && organisationForm.controls['value'].errors"
          >
            <label class="nhsuk-label" for="key">Organisation Value</label>
            <input class="nhsuk-input" id="value" name="value" type="text" formControlName="value" />
            @if (organisationForm.controls['value'].errors && formSubmitted) {
              <span class="nhsuk-error-message mb-0">
                <span class="nhsuk-u-visually-hidden">Error:</span>
                The value can't be empty.
              </span>
            }
          </div>
        }

        <div
          class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
          [class.invalid]="formSubmitted && organisationForm.controls['authorityType'].errors"
        >
          <label class="nhsuk-label" for="authorityType">Authority Type</label>
          <select class="nhsuk-select" id="authorityType" name="authorityType" formControlName="authorityType">
            <option value="-1" selected>-- Choose an Authority Type --</option>
            <option value="ICB">ICB</option>
            <option value="LA">LA</option>
            <option value="LEA">LEA</option>
          </select>
          @if (organisationForm.controls['authorityType'].errors && formSubmitted) {
            <span class="nhsuk-error-message mb-0">
              <span class="nhsuk-u-visually-hidden">Error:</span>
              The Authority Type can't be empty.
            </span>
          }
        </div>

        <div
          class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
          [class.invalid]="formSubmitted && organisationForm.controls['contract'].errors"
        >
          <label class="nhsuk-label" for="contract">Contract</label>
          <select class="nhsuk-select" id="contract" name="contract" formControlName="contract">
            <option value="-1" selected>-- Choose a Contract --</option>
            <option value="BGSW">BGSW</option>
            <option value="CM">CM</option>
            <option value="GM">GM</option>
            <option value="STV">STV</option>
            <option value="SW">SW</option>
          </select>
          @if (organisationForm.controls['contract'].errors && formSubmitted) {
            <span class="nhsuk-error-message mb-0">
              <span class="nhsuk-u-visually-hidden">Error:</span>
              The Contract can't be empty.
            </span>
          }
        </div>

        <div
          class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
          [class.invalid]="formSubmitted && organisationForm.controls['area'].errors"
        >
          <label class="nhsuk-label" for="area">Area</label>
          <input
            class="nhsuk-input"
            id="area"
            name="area"
            type="text"
            placeholder="XXX SURGERY"
            formControlName="area"
          />
          @if (organisationForm.controls['area'].errors && formSubmitted) {
            <span class="nhsuk-error-message mb-0">
              <span class="nhsuk-u-visually-hidden">Error:</span>
              The Area can't be empty.
            </span>
          }
        </div>

        <div
          class="nhsuk-form-group nhsuk-grid-column-one-third p-i-0"
          [class.invalid]="formSubmitted && organisationForm.controls['DataSourceId'].errors"
        >
          <label class="nhsuk-label" for="dataSourceId">Data source ID</label>
          <select class="nhsuk-select" id="dataSourceId" name="dataSourceId" formControlName="DataSourceId">
            <option value="-1" selected>-- Choose a Source ID --</option>
            <option value="1">1</option>
            <option value="2">2</option>
          </select>
          @if (organisationForm.controls['DataSourceId'].errors && formSubmitted) {
            <span class="nhsuk-error-message mb-0">
              <span class="nhsuk-u-visually-hidden">Error:</span>
              The Data source ID can't be empty.
            </span>
          }
        </div>
      }

      <div class="flex space-between">
        <div class="flex gap-16">
          <button [disabled]="isSaving" class="nhsuk-button" data-module="nhsuk-button" type="submit">
            @if (isSaving) {
              <app-loading-spinner />
            } @else {
              <span>Save</span>
            }
          </button>

          <button
            class="nhsuk-button nhsuk-button--secondary"
            data-module="nhsuk-button"
            type="button"
            (click)="onCancel()"
          >
            Cancel
          </button>
        </div>
        @if (isEditing) {
          <button
            class="nhsuk-button nhsuk-button--warning"
            data-module="nhsuk-button"
            type="button"
            (click)="onDelete()"
          >
            Delete
          </button>
        }
      </div>
    </form>
    @if (showConfirmDialog) {
      <app-confirmation-dialogue
        title="Delete Confirmation"
        message="Are you sure you want to delete this item? This action cannot be undone."
        (confirm)="onConfirmDelete()"
        (cancelEvent)="onCancelDelete()"
      />
    }
  }

  @if (isLoading) {
    <app-loading-spinner />
  }
</section>
